/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is FD interest taxable?`)
};

const es_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿El interés del FD está gravado?`)
};

const de_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind FD-Zinsen steuerlich absetzbar?`)
};

const nl_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is FD-rente belastbaar?`)
};

const fr_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les intérêts FD sont-ils imposables ?`)
};

const it_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'interesse FD è tassabile?`)
};

const pt_br2_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juros de FD são tributáveis?`)
};

const pt_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O juro FD é tributável?`)
};

const ja_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FD利息は課税対象ですか？`)
};

const zh_sip_fd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期存款利息是否需要纳税？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_fd_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_fd_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_fd_faq2_q", locale)
	if (locale === "en") return en_sip_fd_faq2_q(inputs)
	if (locale === "es") return es_sip_fd_faq2_q(inputs)
	if (locale === "de") return de_sip_fd_faq2_q(inputs)
	if (locale === "nl") return nl_sip_fd_faq2_q(inputs)
	if (locale === "fr") return fr_sip_fd_faq2_q(inputs)
	if (locale === "it") return it_sip_fd_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_fd_faq2_q(inputs)
	if (locale === "pt") return pt_sip_fd_faq2_q(inputs)
	if (locale === "ja") return ja_sip_fd_faq2_q(inputs)
	return zh_sip_fd_faq2_q(inputs)
};